import * as Action from './action';

const defineInitialState = () => ({
  isAuthenticated: false,
  client: null,
  warehouse: null,
  selectedWarehouse: null,
  session: null,
  token: '',
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$signin.REQUEST:
      return {
        ...state,
        warehouse: null,
        client: null,
        session: null,
        token: '',
      };
    case Action.$signin.SUCCESS:
      return {
        isAuthenticated: true,
        client: action.response.client,
        warehouse: action.response.warehouse,
        session: {
          user: action.response.user,
          usergroup: action.response.usergroup,
          privileges: action.response.privileges,
        },
        token: action.response.token,
      };
    case Action.$fetchProfile.SUCCESS:
      return {
        ...state,
        client: action.response.client,
        warehouse: action.response.warehouse,
        session: {
          user: action.response.user,
          usergroup: action.response.usergroup,
          privileges: action.response.privileges,
        },
      };
    case Action.$logout.ACTION:
      return {
        isAuthenticated: false,
        client: null,
        warehouse: null,
        session: null,
        token: '',
      };
    case Action.$warehouse.ACTION:
      console.log('============selectedWarehouse================')
      return {
        ...state,
        selectedWarehouse: action?.payload,
      };
    default:
      return state;
  }
}

export function persister({ isAuthenticated, client, warehouse, selectedWarehouse, session, token }) {
  return {
    isAuthenticated,
    client,
    warehouse,
    selectedWarehouse,
    session,
    token,
  };
}
